// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const checkNotEmpty = (items?: any): boolean => {
  if (items !== null) {
    if (Array.isArray(items)) {
      if (!items.length) {
        return false
      } else {
        return true
      }
    } else if (typeof items === 'string') {
      if (!items.length) {
        return false
      } else {
        return true
      }
    }
  } else {
    return false
  }
  return items ?? false
}
